import * as firebase from 'firebase';
import FirebaseTools from './FirebaseTools';

class FirebaseCoins {
  constructor() {
    this.firebase = FirebaseTools.firebase;
    this.db = firebase.firestore(this.firebase.app);
    this.collection = this.db.collection('coins');
  }

  async getCoins() {
    return await this.collection.get().then((coins) => coins.docs.map((coin) => coin.data()));
  }

  async addCoin(coin) {
    const docId = `coin-${coin.id}-${(+new Date()).toString()}`;
    const meta = { createdAt: new Date(), modifiedAt: new Date(), docId };
    const data = Object.assign({}, coin, meta);
    await this.collection.doc(docId).set(data);
  }

  async updateCoin(coin) {
    const { docId } = coin;
    await this.collection.doc(docId).set(coin);
    return await this.collection.doc(docId).get().then(doc => doc.data());
  }

  async removeCoin({ docId }) {
    await this.collection.doc(docId).delete();
  }

  parseCoin(coin) {
    return {
      id: coin.id,
      country: coin.country.name,
      images: {
        copyright: coin.images.copyright,
        obverse: coin.images.obverse.fullsize,
        reverse: coin.images.reverse.fullsize,
      },
      metal: coin.metal || 'undefined',
      rarity: coin.rarity_index || 'undefined',
      shape: coin.shape || 'undefined',
      name: coin.title,
      value: coin.value || 'undefined',
      weight: coin.weight || 0,
      yearsRange: coin.years_range || 'undefined',
    };
  }
}

export default new FirebaseCoins();
